export default __webpack_public_path__ + "static/media/Clock_Black.804f8596.svg";